import React from "react";
import { connect } from "react-redux";
import Highlighter from "react-highlight-words";
import { Row, Col } from "antd";
import PropTypes from 'prop-types';
import TransactionDetailsTable from "./../Components/TransactionDetailsTable/TransactionDetailsTable.js";
import {
  ColumnHeader,
  ImgRec
} from "./../Components/BalanceDetailsTable/styles.js";
import recurringIcon from "./../../../assets/icons/recurring-icon.svg";
import grantIcon from "./../../../assets/icons/grant-agreement.svg";
import TitleNode from "./../Components/CardComponent/TitleNode.js";
import CardComponent from "./../Components/CardComponent/CardComponent.js";
import { DataVal, TxnVal } from "./../Components/CardComponent/styles.js";
import formatter from './../../../utils/formatter';
import { selectHeader } from "../../../actions/globalActions";
import history from "./../../../history/history";
import { milliToDate, recordError } from './../../../utils/commonUtil';
import { sortAsNegativeSymbol } from './../../../utils/sorter';
import { getParenthesis } from './../Pages/txnUitls';
import { TableData } from "./TransactionDetailsTable/styles.js";
import { renderDate } from "../Pages/txnUitls";
import queryString from "query-string";

export const renderText = (text, searchText) => {
  if (text) {
    return (
      <TableData>
        <Highlighter
          highlightStyle={{
            color: "black",
            fontWeight: 600,
            backgroundColor: "transparent"
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text}>
          {text}
        </Highlighter>
      </TableData>
    )
  } else {
    return <TableData>-</TableData>
  }
}

export const renderTxnView = function (txnId, data, isMobile, searchText) {
  if (txnId) {
    switch (data.tabType) {
      case 'Contribution':
        return (
          <>
            {isMobile ? <TitleNode title="Transaction ID" /> : ''}
            {
              (data.reversal === true) ?
                <TableData>
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={txnId}>
                    {txnId}
                  </Highlighter>
                </TableData>
                :
                <TxnVal onClick={() => goToTxnView(txnId, data)}>
                  <Highlighter
                    highlightStyle={{
                      color: "black",
                      fontWeight: 600,
                      backgroundColor: "transparent"
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={txnId}>
                    {txnId}
                  </Highlighter>
                </TxnVal>
            }
          </>

        );
      case 'Grant':
        return (
          <>
            {isMobile ? <TitleNode title="Transaction ID" /> : ''}
            <TxnVal isDisabled={data.reversal} onClick={!data.reversal ? () => viewGrants(txnId, data) : null}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={txnId}>
                {txnId}
              </Highlighter>
            </TxnVal>
          </>

        );
      case 'Exchange':
        const isLCP = data.isLcpIncluded;
        return (
          <>
            {isMobile ? <TitleNode title="Transaction ID" /> : ''}
            <TxnVal isDisabled={isLCP} onClick={!isLCP ? () => viewExchange(txnId) : null}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={txnId}>
                {txnId}
              </Highlighter>
            </TxnVal>
          </>
        );
      default:
        return (
          <>
            {isMobile ? <TitleNode title="Transaction ID" /> : ''}
            <TxnVal isDisabled={false} onClick={() => viewOtherTransaction(txnId)}>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={txnId}>
                {txnId}
              </Highlighter>
            </TxnVal>
          </>
        )
    }
  } else {
    return (
      <>
        {isMobile ? <TitleNode title="Transaction ID" /> : ''}
        <TxnVal>-</TxnVal>
      </>
    )
  }
}

export const goToTxnView = (txnId, data) => {
  try {
    selectHeader('Contribution Activity');
    history.push({ pathname: '/contributions/activity/view', state: { transactionId: txnId, status: data.status, giftId: data.giftId } });
  } catch (error) {
    recordError(error);
  }
}

export const viewOtherTransaction = (id) => {
  history.push({
    pathname: "/my-account/other-transaction",
    state: {
      transactionId: id,
    }
  });
};

export const viewGrants = (id, data) => {
  try {
    let checkClearedDate = data.checkClearedDate;
    history.push({
      pathname: "/grants/activity/view",
      search: queryString.stringify({ grantId: id }),
      state: { checkClearedDate }
    })
  } catch (error) {
    recordError(error);
  }
};

export const viewExchange = (id) => {
  history.push(`/investments/recommend-an-exchange/${id}/view?type=onetime`);
};

export const renderAmount = (text, data, searchText) => {
  if (text && text !== "-") {
    let dollarsAmount = formatter({
      value: text,
      fieldSuffix: 'Dollars',
    })
    const isParenthesis = getParenthesis(data)
    if (isParenthesis) {
      return (
        <TableData>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={`(${dollarsAmount})`}>
            {dollarsAmount}
          </Highlighter>
        </TableData>
      )
    } else {
      return (
        <TableData>
          <Highlighter
            highlightStyle={{
              color: "black",
              fontWeight: 600,
              backgroundColor: "transparent"
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={dollarsAmount}>
            {dollarsAmount}
          </Highlighter>
        </TableData>
      )
    }
  } else {
    return <TableData>{(text === 0 ? '$0.00' : '-')}</TableData>
  }
}

export const renderRecur = (recur, data) => {
  if (recur) {
    return (<TableData><ImgRec><img src={recurringIcon} alt="Recurring" /></ImgRec></TableData>);
  } else if (data.grantAgreementPayement) {
    return (<TableData><ImgRec><img src={grantIcon} alt="Recurring" /></ImgRec></TableData>);
  } else {
    return (<TableData></TableData>)
  }
}

export const AllTransactionTable = ({searchText, selectHeader, allTransactionData}) => {

  const columns = [
    {
      title: <ColumnHeader>Transaction ID</ColumnHeader>,
      render: (txnId, data) => renderTxnView(txnId, data, false, searchText),
      dataIndex: "transactionId",
      key: "transactionId",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.transactionId.localeCompare(b.transactionId) }
    },
    {
      title: <ColumnHeader>Entered Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "enteredDate",
      key: "enteredDate",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.enteredDate - b.enteredDate }
    },
    {
      title: <ColumnHeader>Type</ColumnHeader>,
      render: (text) => renderText(text, searchText),
      dataIndex: "tabType",
      key: "tabType",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.tabType.localeCompare(b.tabType) }
    },
    {
      title: <ColumnHeader>Dollar amount</ColumnHeader>,
      render: (text, data) => renderAmount(text, data, searchText),
      dataIndex: "amount",
      key: "amount",
      width: 130,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => {
        const aParenthesis = getParenthesis(a);
        const bParenthesis = getParenthesis(b);
        return sortAsNegativeSymbol(Math.abs(a.amount), Math.abs(b.amount), aParenthesis, bParenthesis);
      }
    },
    {
      title: <ColumnHeader>Trade Date</ColumnHeader>,
      render: (date) => renderDate(date, searchText),
      dataIndex: "tradeDate",
      key: "tradeDate",
      width: 100,
      sortDirections: ["ascend", "descend"],
      sorter: (a, b) => { return a.tradeDate - b.tradeDate }
    },
    {
      title: null,
      render: renderRecur,
      dataIndex: "recurring",
      key: "recurring",
      width: 100
    }
  ];

  const renderTitleGrid = pool => {
    return (
      <>
        <TitleNode title="Entered Date" />
        <DataVal>{milliToDate(pool)}</DataVal>
      </>
    )
  };

  const renderRecurring = (data) => {
    if (data.recurring) {
      return (
        <img src={recurringIcon} alt="Recurring" />
      )
    }
    if (data.grantAgreementPayement) {
      return (
        <img src={grantIcon} alt="Recurring" />
      )
    }
  }

  const renderFixGrid = ({ each, gridName, type }) => {
    if (type === 'amount') {
      let dollarsAmount = formatter({
        value: each[gridName],
        fieldSuffix: 'Dollars',
      })
      const isParenthesis = getParenthesis(each)
      if (isParenthesis) {
        return (
          <>
            <TitleNode title="Dollar amount" />
            <DataVal>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={`${dollarsAmount}`}>
                {dollarsAmount}
              </Highlighter>
            </DataVal>
          </>
        );
      } else {
        return (
          <>
            <TitleNode title="Dollar amount" />
            <DataVal>
              <Highlighter
                highlightStyle={{
                  color: "black",
                  fontWeight: 600,
                  backgroundColor: "transparent"
                }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={dollarsAmount}>
                {dollarsAmount}
              </Highlighter>
            </DataVal>
          </>
        );
      }

    } else if (type === 'tabType') {
      let value = '-'
      {
        (type === 'date' && each[gridName])
          ? value = milliToDate(each[gridName])
          : value = each[gridName]
      }
      return (
        <>
          <TitleNode title="Type" />
          <DataVal>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={value}>
              {value}
            </Highlighter>
          </DataVal>
        </>
      );
    } else {
      let value = '-'
      {
        (type === 'date' && each[gridName])
          ? value = milliToDate(each[gridName])
          : value = each[gridName]
      }
      return (
        <>
          <TitleNode title={gridName} />
          <DataVal>
            <Highlighter
              highlightStyle={{
                color: "black",
                fontWeight: 600,
                backgroundColor: "transparent"
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={value}>
              {value}
            </Highlighter>
          </DataVal>
        </>
      );
    }
  };

  const destObj = (each, index) => {
    return [
      {
        name: "transactionId",
        type: "FixGrid",
        gridWidth: "50",
        render: renderTxnView(each['transactionId'], each, true, searchText),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "enteredDate",
        gridWidth: "50",
        type: "FixGrid",
        render: renderTitleGrid(each.enteredDate),
        ptop: true,
        pbottom: true,
        pright: true
      },
      {
        name: "type",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "tabType", type: 'tabType' }),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: " dollarAmount",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "amount", type: 'amount' }),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "tradeDate",
        type: "FixGrid",
        gridWidth: "50",
        render: renderFixGrid({ each, gridName: "tradeDate", type: 'date' }),
        ptop: true,
        pbottom: true,
        pleft: true
      },
      {
        name: "recurring",
        type: "FixGrid",
        gridWidth: "50",
        render: renderRecurring(each),
        ptop: true,
        pbottom: true,
        pleft: true
      }
    ];
  };

  return (
    <Row id="table-search-allTransactionTable" data-test="all-transaction-table">
      <Col lg={24} md={0} xs={0}>
        <TransactionDetailsTable data-test="all-transaction-table-component" className="allTransactionTab" tabIdentifier="AllTransactions" tabName="all_transactions" scroll={{ y: 500 }} columns={columns} data={allTransactionData} searchText={searchText} />
      </Col>
      <Col lg={0} md={24} xs={24} className="mobCard">
        <CardComponent data-test="all-transaction-table-mobile-component" tabName="all_transactions" destObj={destObj} data={allTransactionData} searchText={searchText} />
      </Col>
    </Row>
  );
};

AllTransactionTable.propTypes = {
  searchText: PropTypes.string,
  allTransactionData: PropTypes.array
}

const mapStateToProps = state => ({
  data: state.getIn(["transactionSummary", "transactionalDetails", "data"])
});
const mapDispatchToProps = dispatch => {
  return {
    selectHeader: data => dispatch(selectHeader(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AllTransactionTable);
